module.exports = __webpack_public_path__ + "img/kopsurat_jmc_header.3ff7eec3.png";